import { render, staticRenderFns } from "./PluginUsercentrics.vue?vue&type=template&id=0180f4a8"
import script from "./PluginUsercentrics.vue?vue&type=script&lang=js"
export * from "./PluginUsercentrics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0180f4a8')) {
      api.createRecord('0180f4a8', component.options)
    } else {
      api.reload('0180f4a8', component.options)
    }
    module.hot.accept("./PluginUsercentrics.vue?vue&type=template&id=0180f4a8", function () {
      api.rerender('0180f4a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings/plugins/PluginUsercentrics.vue"
export default component.exports